{
  "signIn": "Connexion",
  "subHeader": "Entrez vos identifiants de connexion ci-dessous",
  "email": "Email",
  "password": "Mot de passe",
  "forgot": "Mot de passe oublié?",
  "noAccount": "Pas de compte pour le moment ?",
  "getStarted": "Temps de commencer",
  "fieldRequired": "Ce champs est obligatoire",
  "valueShouldBeAnEmail": "Invalid value for the filed, it should be a valid E-mail"
}
